import React, {useState, useEffect, useRef} from 'react';
import {apiUrl} from "../../../services/constants";

// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import "../../../css/slider/styles.css";

// import required modules
import {Autoplay, FreeMode, Navigation, Thumbs} from 'swiper/modules';

const ImageSlider = ({images, slidesPerView}) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    const swiperRef = React.useRef(null);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    // useEffect(() => {
    //     if (swiperRef.current) {
    //         swiperRef.current.slideTo(0);
    //     }
    // }, [swiperRef.current]);

   const slides = images.map((img, index) => {
        return (
            <SwiperSlide key={index} className="swiper-slide-custom">

                <img
                    src={apiUrl + img.url}
                    alt={`Slide ${index}`}
                    style={{}}
                />
            </SwiperSlide>
        );
    });

    return (
        <div
            style={styles.sliderContainer}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >

            <Swiper  onSwiper={(swiper) => {
                swiperRef.current = swiper;  // Сохраняем экземпляр слайдера в рефе
            }}
                slidesPerView={1}
                spaceBetween={5}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                }}
                loop={true}
                navigation={isHovered}
                modules={[Autoplay, FreeMode, Navigation, Thumbs]}
                thumbs={{swiper: thumbsSwiper}}
                centeredSlides={true}

                className="mySwiper2"
            >
                {slides}

            </Swiper>

            {
                images.length > 1 &&
                <Swiper
                    modules={[Thumbs, FreeMode, Navigation]}
                    freeMode={true}
                    navigation={true}
                    watchSlidesProgress

                    breakpoints={{
                        640: {
                            slidesPerView: 4,
                        },
                        768: {
                            slidesPerView: 8,
                        },
                    }}
                    loop={false}
                    spaceBetween={5}

                    onSwiper={setThumbsSwiper}
                    initialSlide={0}
                    className="mySwiper"
                >
                    {
                        images.map((img, index) => {
                            return (
                                <SwiperSlide key={index}>

                                    <img
                                        src={apiUrl + img.url}
                                        alt={`Slide ${index}`}
                                        style={{}}
                                    />
                                </SwiperSlide>
                            );
                        })
                    }
                </Swiper>
            }

        </div>
    );
};

const styles = {
    sliderContainer: {
        width: '100%',
        maxWidth: '800px',
        height: '500px',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
};

export default ImageSlider;
